
export default function ReleaseNotesController(
) {
  const vm = this;

  vm.isExpanded = false;

  vm.orderBy = '-releaseDateKey';

  vm.handleExpand = _handleExpand;
  vm.handleSort = _handleSort;

  _activate();

  function _activate() {
    _initEventListeners();
  }

  /** *********************************************
   * Event Handlers
   */

  function _handleExpand() {
    vm.isExpanded = !vm.isExpanded;
  }

  function _handleSort(propertyName) {
    if (vm.orderBy === propertyName) {
      if (propertyName.startsWith('-')) {
        propertyName = propertyName.substring(1);
      } else {
        propertyName = `-${propertyName}`;
      }
    }
    vm.orderBy = propertyName;
  }

  /** *********************************************
   * Private Functions
   */

  function _initEventListeners() {
  }
}

ReleaseNotesController.$inject = [];
